import { render, staticRenderFns } from "./mainPanel.vue?vue&type=template&id=2b9d5356&scoped=true"
import script from "./mainPanel.vue?vue&type=script&lang=js"
export * from "./mainPanel.vue?vue&type=script&lang=js"
import style0 from "./mainPanel.vue?vue&type=style&index=0&id=2b9d5356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d5356",
  null
  
)

export default component.exports